import { combineReducers } from "redux"

// Commons Reducers
import alarmeReducer from "../commons-reducers/alarmeReducer"
import cachedReducer from "../commons-reducers/cachedReducer"
import composicaoReducer from "../commons-reducers/composicaoReducer"
import frequenciaReducer from "../commons-reducers/frequenciaReducer"
import justificativaReducer from "../commons-reducers/justificativaReducer"
import materialReducer from "../commons-reducers/materialReducer"
import registroReducer from "../commons-reducers/registroReducer"
import setorReducer from "../commons-reducers/setorReducer"
import statusReducer from "../commons-reducers/statusReducer"
import turnoReducer from "../commons-reducers/turnoReducer"
import unidadeMaterialReducer from "../commons-reducers/unidadeMaterialReducer"
import unidadeReducer from "../commons-reducers/unidadeReducer"

// Gestão Reducers
import grupoReducer from "../gestao-reducers/grupoReducer"
import teamMemberReducer from "../gestao-reducers/teamMemberReducer"
import timeReducer from "../gestao-reducers/timeReducer"

// Processo Reducers
import FolhaDeVerificacaoReducer from "../processo-reducers/FolhaDeVerificacaoReducer"
import cadernoDeVerificacaoReducer from "../processo-reducers/cadernoDeVerificacaoReducer"
import calculoDeCorrecaoReducer from "../processo-reducers/calculoDeCorrecaoReducer"
import controleReducer from "../processo-reducers/controleReducer"
import especificacaoReducer from "../processo-reducers/especificacaoReducer"
import fluxoDeProcessoReducer from "../processo-reducers/fluxoDeProcessoReducer"
import limiteDeControleReducer from "../processo-reducers/limiteDeControleReducer"
import linhaDePlanoDeControleReducer from "../processo-reducers/linhaDePlanoDeControleReducer"
import operacaoReducer from "../processo-reducers/operacaoReducer"
import ordemDeCorrecaoReducer from "../processo-reducers/ordemDeCorrecaoReducer"
import parametroReducer from "../processo-reducers/parametroReducer"
import planoDeControleReducer from "../processo-reducers/planoDeControleReducer"
import processoReducer from "../processo-reducers/processoReducer"
import regraDeCorrecaoReducer from "../processo-reducers/regraDeCorrecaoReducer"
import reporteReducer from "../processo-reducers/reporteReducer"

// Suprimentos Reducers
import requisicaoMaterialReducer from "../suprimentos-reducers/requisicaoMaterialReducer"

// Default Reducers
import genericPickerReducer from "./genericPickerReducer"
import globalConfig from "./globalConfigReducer"
import globalErrorReducer from "./globalErrorReducer"
import notificationReducer from "./notificationReducer"
import pickersReducer from "./pickersReducer"
import timerReducer from "./timerReducer"

const appReducer = combineReducers({
	alarme: alarmeReducer,
	cached: cachedReducer,
	cadernoDeVerificacao: cadernoDeVerificacaoReducer,
	calculoDeCorrecao: calculoDeCorrecaoReducer,
	composicao: composicaoReducer,
	controle: controleReducer,
	especificacao: especificacaoReducer,
	fluxoDeProcesso: fluxoDeProcessoReducer,
	folhaDeVerificacao: FolhaDeVerificacaoReducer,
	frequencia: frequenciaReducer,
	global: globalConfig,
	globalError: globalErrorReducer,
	grupo: grupoReducer,
	justificativa: justificativaReducer,
	limiteDeControle: limiteDeControleReducer,
	linhaDePlanoDeControle: linhaDePlanoDeControleReducer,
	material: materialReducer,
	operacao: operacaoReducer,
	parametro: parametroReducer,
	picker: genericPickerReducer,
	pickers: pickersReducer,
	planoDeControle: planoDeControleReducer,
	processo: processoReducer,
	registro: registroReducer,
	regraDeCorrecao: regraDeCorrecaoReducer,
	requisicaoMaterial: requisicaoMaterialReducer,
	reporte: reporteReducer,
	setor: setorReducer,
	status: statusReducer,
	team: timeReducer,
	teamMember: teamMemberReducer,
	timer: timerReducer,
	turno: turnoReducer,
	unidade: unidadeReducer,
	unidadeMaterial: unidadeMaterialReducer,
	notification: notificationReducer,
	ordemDeCorrecao: ordemDeCorrecaoReducer
})

const rootReducer = (state, action) => {
	// when a logout action is dispatched it will reset redux state
	if (action && action.type === "eraseStore") {
		try {
			// eslint-disable-next-line no-console
			console.warn('[rootReducer] eraseStore action detected, clearing state')
			// eslint-disable-next-line no-console
			console.trace()
		} catch (e) { }

		// Preserve needUserLogin state during store reset, so 403 API retries aren't aborted prematurely
		const preservedNeedUserLogin = state?.global?.needUserLogin;

		state = undefined;

		let newState = appReducer(state, action);

		if (preservedNeedUserLogin) {
			newState = {
				...newState,
				global: {
					...newState.global,
					needUserLogin: preservedNeedUserLogin
				}
			};
		}

		return newState;
	}

	return appReducer(state, action)
}

export default rootReducer
